module.exports = __webpack_public_path__ + "static/media/IO.ad424ba1.svg";